function LassoSelectorTool() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="#C1C7CE"
      viewBox="0 0 24 24"
    >
      <path
        fill="#C1C7CE"
        d="M4.025 11.1l-2-.2c.1-.767.27-1.513.513-2.238.241-.725.57-1.412.987-2.062l1.7 1.05a7.146 7.146 0 00-.787 1.65c-.192.583-.33 1.183-.413 1.8zm.9 7.9A9.3 9.3 0 013.5 17.238c-.4-.642-.725-1.321-.975-2.038l1.9-.65a7.903 7.903 0 001.9 3.05l-1.4 1.4zm2.75-13.8l-1.05-1.7a9.198 9.198 0 012.063-.987c.725-.242 1.47-.413 2.237-.513l.2 2c-.617.083-1.217.22-1.8.412a7.146 7.146 0 00-1.65.788zm4.3 16.75c-.583 0-1.162-.046-1.737-.137a7.568 7.568 0 01-1.663-.463l.65-1.9c.45.15.9.27 1.35.363.45.091.917.137 1.4.137v2zm5.65-15.65a7.9 7.9 0 00-3.05-1.9l.65-1.9c.717.25 1.396.575 2.037.975A9.3 9.3 0 0119.026 4.9l-1.4 1.4zm2.15 14.85l-2.8-2.8v2.6h-2v-6h6v2h-2.6l2.8 2.8-1.4 1.4zm.2-9.2c0-.483-.046-.95-.138-1.4-.091-.45-.212-.9-.362-1.35l1.9-.65c.217.533.37 1.087.462 1.662.092.575.138 1.155.138 1.738h-2z"
      ></path>
    </svg>
  );
}

export default LassoSelectorTool;
